module.exports = __webpack_public_path__ + "img/104.7.60f6e51e.png";